import { render, staticRenderFns } from "./teamDialog.vue?vue&type=template&id=a2ab53cc&scoped=true&lang=pug"
import script from "./teamDialog.vue?vue&type=script&lang=js"
export * from "./teamDialog.vue?vue&type=script&lang=js"
import style0 from "./teamDialog.vue?vue&type=style&index=0&id=a2ab53cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ab53cc",
  null
  
)

export default component.exports